import React, { useEffect, useState } from 'react'
import CourseCard from '../../Reusable/CourseCard'
import { courses_data } from './course_data'
import { axiosInstance } from '../config';
import Loader from '../../common/Loader';

const CourseList = () => {

    const [Courses , setCourses] = useState([]);
    const [Loading,setLoading] = useState(false);

    useEffect(() => {
        getData();
    },[])

    function getData() {
        setLoading(true)

        axiosInstance.get(`get-cources`)
            .then(res => {
                // console.log(res.data)
                setCourses(
                    res.data.cources
                      .filter(course => course.status === 0)  // Filter out courses with status equal to 1
                      .reverse()    
                );
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <>
            {Loading && <Loader/>}
            <section className="course-style-three alternat-2">
                <div className="shape">
                    <div
                        className="shape-1"
                        style={{ backgroundImage: "url(assets/images/shape/shape-87.png)" }}
                    />
                    <div
                        className="shape-3 float-bob-x"
                        style={{ backgroundImage: "url(assets/images/shape/shape-6.png)" }}
                    />
                </div>
                <div className="auto-container">
                    <div className="sec-title centred">
                        <h2>Course to drive with confidence</h2>
                    </div>
                    <div className="row clearfix">
                        {
                            Courses.map((course, index) => {
                                return <CourseCard key={index} course={course} />
                            })
                        }
                    </div>
                </div>
            </section>

        </>
    )
}

export default CourseList